var _defs, _rect, _path, _circle, _clipPath, _path2, _g, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagOfBrazil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 720,
    height: 504,
    viewBox: "-2100 -1470 4200 2940",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "D",
    d: "M -31.5,0 h 33 a 30 30 0 0 0 30,-30 v -10 a 30 30 0 0 0 -30,-30 H -31.5 z M -18.5,-13 h 19 a 19 19 0 0 0 19,-19 v -6 a 19 19 0 0 0 -19,-19 H -18.5 z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M 0,0 h 63 v -13 H 12 v -18 h 40 v -12 h -40 v -14 H 60 v -13 H 0 z",
    transform: "translate(-31.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M -26.25,0 h 52.5 v -12 h -40.5 v -16 h 33 v -12 h -33 v -11 H 25 v -12 H -26.25 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "gcut"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -31.5,0 v -70 h 63 v 70 z M 0,-47 v 12 h 31.5 v -12 z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    clipPath: "url(#gcut)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: -35,
    width: 26.5,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: -35,
    width: 10,
    height: 35
  })), /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "M -31.5,0 h 12 v -48 l 14,48 h 11 l 14,-48 V 0 h 12 V -70 h -17.5 l -14,48 l -14,-48 H -31.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "M 0,0 a 31.5 35 0 0 0 0,-70 a 31.5 35 0 0 0 0,70 M 0,-13 a 18.5 22 0 0 0 0,-44 a 18.5 22 0 0 0 0,44",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    d: "M -31.5,0 h 13 v -26 h 28 a 22 22 0 0 0 0,-44 h -40 z M -18.5,-39 h 27 a 9 9 0 0 0 0,-18 h -27 z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28,0 c 0,-10 0,-32 -15,-32 h -19 c 22,0 22,22 22,32"
  })), /*#__PURE__*/React.createElement("path", {
    id: "S",
    d: "M -15.75,-22 C -15.75,-15 -9,-11.5 1,-11.5 C 11,-11.5 15.74,-14.75 15.75,-19.25 C 15.75,-33.5 -31,-24.5 -30.75,-49.5 C -30.5,-71 -6,-70 3,-70 C 12,-70 29,-66 28.75,-48.75 L 13.5,-48.75 C 13.5,-56.25 6.5,-59 -1.5,-59 C -9.25,-59 -14.75,-57.75 -14.75,-50.5 C -15,-38.75 31.5,-46.5 31.5,-21.75 C 31.5,-3.5 13.5,0 0,0 C -11.5,0 -31.55,-4.5 -31.5,-22 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "star",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M 0,-1 v 1 h .5",
    transform: "rotate(18 0,-1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "scale(-1,1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(-144)"
  })), /*#__PURE__*/React.createElement("use", {
    id: "star1",
    xlinkHref: "#star",
    transform: "scale(31.5)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "star2",
    xlinkHref: "#star",
    transform: "scale(26.25)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "star3",
    xlinkHref: "#star",
    transform: "scale(21)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "star4",
    xlinkHref: "#star",
    transform: "scale(15)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "star5",
    xlinkHref: "#star",
    transform: "scale(10.5)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: "-50%",
    y: "-50%",
    width: "100%",
    height: "100%",
    fill: "#009b3a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M -1743,0 0,1113 1743,0 0,-1113 z",
    fill: "#fedf00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 735,
    fill: "#002776"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "band"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 735
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M -2205,1470 a 1785 1785 0 0 1 3570,0 h -105 a 1680 1680 0 1 0 -3360,0 z",
    clipPath: "url(#band)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#009b3a",
    transform: "translate(-420,1470)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    y: -1697.5,
    transform: "rotate(-7)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    y: -1697.5,
    transform: "rotate(-4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D",
    y: -1697.5,
    transform: "rotate(-1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    y: -1697.5,
    transform: "rotate(2)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#M",
    y: -1697.5,
    transform: "rotate(5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    y: -1697.5,
    transform: "rotate(9.75)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P",
    y: -1697.5,
    transform: "rotate(14.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    y: -1697.5,
    transform: "rotate(17.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    y: -1697.5,
    transform: "rotate(20.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G",
    y: -1697.5,
    transform: "rotate(23.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    y: -1697.5,
    transform: "rotate(26.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    y: -1697.5,
    transform: "rotate(29.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S",
    y: -1697.5,
    transform: "rotate(32.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S",
    y: -1697.5,
    transform: "rotate(35.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    y: -1697.5,
    transform: "rotate(38.5)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1CMi",
    xlinkHref: "#star1",
    x: -600,
    y: -132
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1CMa",
    xlinkHref: "#star1",
    x: -535,
    y: 177
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2CMa",
    xlinkHref: "#star2",
    x: -625,
    y: 243
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3CMa",
    xlinkHref: "#star4",
    x: -463,
    y: 132
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B4CMa",
    xlinkHref: "#star2",
    x: -382,
    y: 250
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B5CMa",
    xlinkHref: "#star3",
    x: -404,
    y: 323
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Vir",
    xlinkHref: "#star1",
    x: 228,
    y: -228
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Sco",
    xlinkHref: "#star1",
    x: 515,
    y: 258
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2Sco",
    xlinkHref: "#star3",
    x: 617,
    y: 265
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B5Sco",
    xlinkHref: "#star2",
    x: 545,
    y: 323
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B8Sco",
    xlinkHref: "#star2",
    x: 368,
    y: 477
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B9Sco",
    xlinkHref: "#star3",
    x: 367,
    y: 551
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03BASco",
    xlinkHref: "#star3",
    x: 441,
    y: 419
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03BBSco",
    xlinkHref: "#star2",
    x: 500,
    y: 382
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03BCSco",
    xlinkHref: "#star3",
    x: 365,
    y: 405
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Hya",
    xlinkHref: "#star2",
    x: -280,
    y: 30
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3Hya",
    xlinkHref: "#star3",
    x: 200,
    y: -37
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Cru",
    xlinkHref: "#star1",
    y: 330
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2Cru",
    xlinkHref: "#star2",
    x: 85,
    y: 184
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3Cru",
    xlinkHref: "#star2",
    y: 118
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B4Cru",
    xlinkHref: "#star3",
    x: -74,
    y: 184
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B5Cru",
    xlinkHref: "#star4",
    x: -37,
    y: 235
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1TrA",
    xlinkHref: "#star2",
    x: 220,
    y: 495
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2TrA",
    xlinkHref: "#star3",
    x: 283,
    y: 430
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3TrA",
    xlinkHref: "#star3",
    x: 162,
    y: 412
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Car",
    xlinkHref: "#star1",
    x: -295,
    y: 390
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03C3Oct",
    xlinkHref: "#star5",
    y: 575
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfBrazil);
export default __webpack_public_path__ + "static/media/Flag_of_Brazil.62e1c5da3916cece2a3fd3d78f4fcd53.svg";
export { ForwardRef as ReactComponent };